import p from '../../theme/palette';
import palette from "../../theme/palette";

const styles = {
  multiField: {
    border: '1px solid',
    borderColor: 'transparent',
    borderRadius: 8,
    padding: '0 16px 0px 16px',
    margin: '12px -16px',
    position: 'relative',
    transition: 'all .2s',
  },
  multiFieldError: {
    borderColor: p.error,
    transition: 'all .2s',
  },
  multiFieldErrorText: {
    color: p.error,
    fontSize: 12,
    position: 'absolute',
    bottom: -20,
    left: 16,
  },
  formError: {
    borderLeft: '3px solid',
    borderColor: p.error,
    color: p.error,
    padding: '12px 16px',
    background: p.errorBg,
    borderRadius: '0 8px 8px 0',
    fontSize: 14,
  },
  formFieldHint: {
    fontSize: 12,
    position: 'relative',
    top: -2,
    color: p.fieldHint,
    marginTop: 4,
  },
  accountLogoTitle: {
    color: p.grey300,
    margin: '15px 0 5px 0',
  },
  fieldMaxWidth: {
    maxWidth: 350,
  },
  apikeyCheckbox: {
    fontSize: 18,
  },
  apikeyOptions: {
    marginBottom: 10,
    marginLeft: 40,
  },
  bottomButton: {
    marginLeft: 10,
  },
  bottomButtonRight: {
    right: 30,
    position: 'absolute',
  },
  actions: {
    position: 'absolute',
    right: 30,
  },
  dialogButton: {
    position: 'absolute',
    right: 120,
    bottom: 8,
  },
  dialogButtonInline: {
    backgroundColor: '#dc2626',
    textTransform: 'uppercase',
  },
  iconInInput: {
    position: 'absolute',
    top: '21px',
    left: '12px',
    fontSize: '14px',
    color: palette.fieldHint,
  },
  searchHintStyle: {
    width: '100%',
    paddingLeft: 24,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: palette.fieldHint,
    fontSize: 14,
  },
  warmingContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 16,
    marginLeft: 24,
  },
  warmingRowContainer: {
    display: 'flex',
    width: 'calc(100% - 243px)',
    marginLeft: 24,
    justifyContent: 'flex-end',
    height: 34,
  },
  warmingTitle: {
    color: palette.dialogErrorHeaderBg,
    fontSize: 10,
    opacity: '.7',
    display: 'flex',
    alignItems: 'center',
    maxWidth: 500,
    minWidth: 300,
    marginRight: 24,
  },
  cancelButton: {
    backgroundColor: p.white,
    border: '1px solid ' + p.border,
  },
};

export default styles;
